export const leatherColorObjs = [
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラック', value: 'black', color: '#1E1E1E' }
]

const tgsLeatherColorObjs = [
  { label: 'シャンパンコルク', value: 'champagneCork', color: '#d9c390' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'Rオレンジ', value: 'redOrange', color: '#ff2200' },
  { label: 'レッド', value: 'red', color: '#b30205' },
  { label: 'ブルー', value: 'blue', color: '#193B85' }
]

const gusLeatherColorObjs = [
  { label: 'シャンパンコルク', value: 'champagneCork', color: '#d9c390' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'Rオレンジ', value: 'redOrange', color: '#ff2200' },
  { label: 'レッド', value: 'red', color: '#b30205' },
  { label: 'ブルー', value: 'blue', color: '#193B85' }
]

const dtsLeatherColorObjs = [
  { label: 'シャンパンコルク', value: 'champagneCork', color: '#d9c390' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'Rオレンジ', value: 'redOrange', color: '#ff2200' },
  { label: 'レッド', value: 'red', color: '#b30205' },
  { label: 'ブルー', value: 'blue', color: '#193B85' }
]

export const hamidashiObjs = [
  { label: '切りハミ(ホワイト)', value: 'kirihamiWhite', color: '#fff' },
  { label: '玉ハミ(シャンパンコルク)', value: 'champagneCork', color: '#d9c390' },
  { label: '玉ハミ(オレンジ)', value: 'orange', color: '#FF6C23' },
  { label: '玉ハミ(コルク)', value: 'cork', color: '#CE7220' },
  { label: '玉ハミ(チョコ)', value: 'chocolate', color: '#652821' },
  { label: '玉ハミ(ブラック)', value: 'black', color: '#1E1E1E' },
  { label: '玉ハミ(Rオレンジ)', value: 'redOrange', color: '#ff2200' },
  { label: '玉ハミ(ブルー)', value: 'blue', color: '#193B85' },
  { label: '玉ハミ(ネイビー)', value: 'navy', color: '#2F3542' },
  { label: '玉ハミ(スカイグリーン)', value: 'skyGreen', color: '#94C8BF' },
  { label: '玉ハミ(ホワイト)', value: 'white', color: '#fff' },
  { label: '玉ハミ(イエロー', value: 'yellow', color: '#E2B155' },
  { label: '玉ハミ(スカイブルー)', value: 'SkyBlue', color: '#4EB5DC' },
  { label: '玉ハミ(ピンク)', value: 'pink', color: '#E8AFB0' },
  { label: '玉ハミ(パープル)', value: 'purple', color: '#6a1ca3' },
  { label: '玉ハミ(グレー)', value: 'gray', color: '#8A8C8C' },
  { label: '玉ハミ(グリーン)', value: 'green', color: '#009c09' },
  { label: '玉ハミ(レッド)', value: 'red', color: '#b30205' }
]
export const catcherHamidashiObjs = [
  { label: 'ハミダシなし(ツマミ)', value: 'none', color: '#fff' },
  { label: '切りハミ(ホワイト)', value: 'kirihamiWhite', color: '#fff' },
  { label: '玉ハミ(シャンパンコルク)', value: 'champagneCork', color: '#d9c390' },
  { label: '玉ハミ(オレンジ)', value: 'orange', color: '#FF6C23' },
  { label: '玉ハミ(コルク)', value: 'cork', color: '#CE7220' },
  { label: '玉ハミ(チョコ)', value: 'chocolate', color: '#652821' },
  { label: '玉ハミ(ブラック)', value: 'black', color: '#1E1E1E' },
  { label: '玉ハミ(Rオレンジ)', value: 'redOrange', color: '#ff2200' },
  { label: '玉ハミ(ブルー)', value: 'blue', color: '#193B85' },
  { label: '玉ハミ(ホワイト)', value: 'white', color: '#fff' },
  { label: '玉ハミ(スカイブルー)', value: 'SkyBlue', color: '#4EB5DC' },
  { label: '玉ハミ(ピンク)', value: 'pink', color: '#E8AFB0' },
  { label: '玉ハミ(パープル)', value: 'purple', color: '#6a1ca3' },
  { label: '玉ハミ(グレー)', value: 'gray', color: '#8A8C8C' },
  { label: '玉ハミ(グリーン)', value: 'green', color: '#009c09' },
  { label: '玉ハミ(レッド)', value: 'red', color: '#b30205' }
]

export const edgeObjs = [
  { label: 'シャンパンコルク', value: 'champagneCork', color: '#d9c390' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'Rオレンジ', value: 'redOrange', color: '#ff2200' },
  { label: 'レッド', value: 'red', color: '#b30205' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'ネイビー', value: 'navy', color: '#2F3542' },
  { label: 'スカイグリーン', value: 'skyGreen', color: '#94C8BF' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'イエロー', value: 'yellow', color: '#E2B155' },
  { label: 'スカイブルー', value: 'SkyBlue', color: '#4EB5DC' },
  { label: 'ピンク', value: 'pink', color: '#E8AFB0' },
  { label: 'パープル', value: 'purple', color: '#6a1ca3' },
  { label: 'グレー', value: 'gray', color: '#8A8C8C' },
  { label: 'グリーン', value: 'green', color: '#009c09' }
]

export const laceObjs = [
  { label: 'シャンパンコルク', value: 'champagneCork', color: '#d9c390', availableGlove: true, availableMitt: true },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23', availableGlove: true, availableMitt: false },
  { label: 'コルク', value: 'cork', color: '#CE7220', availableGlove: true, availableMitt: true },
  { label: '中白オレンジ', value: 'materialOrange', color: '#FF6C23', availableGlove: false, availableMitt: true },
  { label: 'チョコ', value: 'chocolate', color: '#652821', availableGlove: true, availableMitt: true },
  { label: 'ブラック', value: 'black', color: '#282925', availableGlove: true, availableMitt: false },
  { label: 'Rオレンジ', value: 'redOrange', color: '#ff2200', availableGlove: true, availableMitt: false },
  { label: '中白Rオレンジ', value: 'materialRedOrange', color: '#ff2200', availableGlove: false, availableMitt: true },
  { label: 'レッド', value: 'red', color: '#b30205', availableGlove: true, availableMitt: false },
  { label: 'ブルー', value: 'blue', color: '#14438F', availableGlove: true, availableMitt: false },
  { label: 'ネイビー', value: 'navy', color: '#2F3542', availableGlove: true, availableMitt: false },
  { label: 'ホワイト', value: 'white', color: '#fff', availableGlove: true, availableMitt: true },
  { label: 'スカイブルー', value: 'SkyBlue', color: '#4EB5DC', availableGlove: true, availableMitt: false },
  { label: '中白スカイブルー', value: 'materialSkyBlue', color: '#4EB5DC', availableGlove: false, availableMitt: true },
  { label: 'イエロー', value: 'yellow', color: '#E2B155', availableGlove: true, availableMitt: false },
  { label: 'ピンク', value: 'pink', color: '#E8AFB0', availableGlove: true, availableMitt: false },
  { label: '中白ピンク', value: 'materialPink', color: '#E8AFB0', availableGlove: false, availableMitt: true },
  { label: 'パープル', value: 'purple', color: '#6a1ca3', availableGlove: true, availableMitt: true },
  { label: 'グレー', value: 'gray', color: '#8A8C8C', availableGlove: true, availableMitt: true },
  { label: 'グリーン', value: 'green', color: '#009c09', availableGlove: true, availableMitt: true },
  { label: '中白スカイグリーン', value: 'materialSkyGreen', color: '#94C8BF', availableGlove: true, availableMitt: false },
  { label: '中白ブラック', value: 'materialBlack', color: '#282925', availableGlove: true, availableMitt: true },
  { label: '中白レッド', value: 'materialRed', color: '#b30205', availableGlove: true, availableMitt: true },
  { label: '中白ブルー', value: 'materialBlue', color: '#14438F', availableGlove: true, availableMitt: true }
]

export const moutonObjs = [
  { label: 'ホワイト', value: 'white', color: '#fff', availableGlove: true },
  { label: 'ブラック', value: 'black', color: '#1E1E1E', availableGlove: true },
  { label: 'パッド', value: 'pad', color: '#1E1E1E', availableGlove: false }
]

export const specifyLabelObjs = [
  { label: '直刺繍', value: 'directEmbroidery' },
  { label: 'ラベル', value: 'label' }
]

export const stitchColorObjs = [
  { label: 'ホワイト', value: 'white', color: '#eee' },
  { label: 'シャンパンコルク', value: 'champagneCork', color: '#fae3af' },
  { label: 'イエロー', value: 'yellow', color: '#E2B155' },
  { label: 'オレンジ', value: 'orange', color: '#e37d00' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコ', value: 'chocolate', color: '#652821' },
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'レッド', value: 'red', color: '#ff2200' },
  { label: 'ブルー', value: 'blue', color: '#002bff' },
  { label: 'ネイビー', value: 'navy', color: '#2F3542' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#4EB5DC' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'パープル', value: 'purple', color: '#6a1ca3' },
  { label: 'グレー', value: 'gray', color: '#8A8C8C' },
  { label: 'グリーン', value: 'green', color: '#009c09' },
  { label: 'スカイグリーン', value: 'skyGreen', color: '#94C8BF' }
]

export const dxmDirectEmbroideryLogoObjs = [
  { label: '直刺繍(ホワイト)', value: 'white', color: '#eee' },
  { label: '直刺繍(シャンパンコルク)', value: 'champagneCork', color: '#d9c390' },
  { label: '直刺繍(イエロー)', value: 'yellow', color: '#E2B155' },
  { label: '直刺繍(オレンジ)', value: 'orange', color: '#e37d00' },
  { label: '直刺繍(コルク)', value: 'cork', color: '#CE7220' },
  { label: '直刺繍(チョコ)', value: 'chocolate', color: '#652821' },
  { label: '直刺繍(ブラック)', value: 'black', color: '#0a0a0a' },
  { label: '直刺繍(レッド)', value: 'red', color: '#ff2200' },
  { label: '直刺繍(ブルー)', value: 'blue', color: '#002bff' },
  { label: '直刺繍(ネイビー)', value: 'navy', color: '#2F3542' },
  { label: '直刺繍(スカイブルー)', value: 'skyBlue', color: '#4EB5DC' },
  { label: '直刺繍(ピンク)', value: 'pink', color: '#ff1493' },
  { label: '直刺繍(パープル)', value: 'purple', color: '#6a1ca3' },
  { label: '直刺繍(グレー)', value: 'gray', color: '#8A8C8C' },
  { label: '直刺繍(グリーン)', value: 'green', color: '#009c09' },
  { label: '直刺繍(スカイグリーン)', value: 'skyGreen', color: '#94C8BF' },
  { label: '直刺繍(蛍光グリーン)', value: 'fluorescenceGreen', color: '#B0CE77' },
  { label: '直刺繍(ゴールド)', value: 'gold', color: '#F3DB32' },
  { label: '直刺繍(シルバー)', value: 'silver', color: '#DCDCDC' }
]

// setter側で使用
export const dxmLabelLogoObjs = [
  { label: 'ラベル(カーキxゴールド)', value: '1', imageUrl: '/dxm/labels/1.jpg' },
  { label: 'ラベル(パープルxゴールド)', value: '2', imageUrl: '/dxm/labels/2.jpg' },
  { label: 'ラベル(オレンジxブルー)', value: '3', imageUrl: '/dxm/labels/3.jpg' },
  { label: 'ラベル(イエローxゴールド)', value: '4', imageUrl: '/dxm/labels/4.jpg' },
  { label: 'ラベル(グリーンxシルバー)', value: '5', imageUrl: '/dxm/labels/5.jpg' },
  { label: 'ラベル(シャンパンコルクxグリーン)', value: '6', imageUrl: '/dxm/labels/6.jpg' },
  { label: 'ラベル(エンジxゴールド)', value: '7', imageUrl: '/dxm/labels/7.jpg' },
  { label: 'ラベル(スカイブルーxゴールド)', value: '8', imageUrl: '/dxm/labels/8.jpg' },
  { label: 'ラベル(ホワイトxブラック)', value: '9', imageUrl: '/dxm/labels/9.jpg' },
  { label: 'ラベル(ホワイトxレッド)', value: '10', imageUrl: '/dxm/labels/10.jpg' },
  { label: 'ラベル(ホワイトxシルバー)', value: '11', imageUrl: '/dxm/labels/11.jpg' },
  { label: 'ラベル(ホワイトxネイビー)', value: '12', imageUrl: '/dxm/labels/12.jpg' },
  { label: 'ラベル(ホワイトxホワイト)', value: '13', imageUrl: '/dxm/labels/13.jpg' },
  { label: 'ラベル(ホワイトxコルク)', value: '14', imageUrl: '/dxm/labels/14.jpg' },
  { label: 'ラベル(ホワイトxグレー)', value: '15', imageUrl: '/dxm/labels/15.jpg' },
  { label: 'ラベル(ホワイトxグリーン)', value: '16', imageUrl: '/dxm/labels/16.jpg' },
  { label: 'ラベル(ホワイトxパープル)', value: '17', imageUrl: '/dxm/labels/17.jpg' },
  { label: 'ラベル(ホワイトxピンク)', value: '18', imageUrl: '/dxm/labels/18.jpg' },
  { label: 'ラベル(ホワイトxゴールド)', value: '19', imageUrl: '/dxm/labels/19.jpg' },
  { label: 'ラベル(ホワイトxオレンジ)', value: '20', imageUrl: '/dxm/labels/20.jpg' },
  { label: 'ラベル(ホワイトxイエロー)', value: '21', imageUrl: '/dxm/labels/21.jpg' },
  { label: 'ラベル(ホワイトxブルー)', value: '22', imageUrl: '/dxm/labels/22.jpg' },
  { label: 'ラベル(ホワイトチョコx)', value: '23', imageUrl: '/dxm/labels/23.jpg' },
  { label: 'ラベル(ホワイトxスカイブルー)', value: '24', imageUrl: '/dxm/labels/24.jpg' },
  { label: 'ラベル(ブラックxチョコ)', value: '25', imageUrl: '/dxm/labels/25.jpg' },
  { label: 'ラベル(ブラックxゴールド)', value: '26', imageUrl: '/dxm/labels/26.jpg' },
  { label: 'ラベル(ブラックxブルー)', value: '27', imageUrl: '/dxm/labels/27.jpg' },
  { label: 'ラベル(ブラックxネイビー)', value: '28', imageUrl: '/dxm/labels/28.jpg' },
  { label: 'ラベル(ブラックxグリーン)', value: '29', imageUrl: '/dxm/labels/29.jpg' },
  { label: 'ラベル(ブラックxスカイブルー)', value: '30', imageUrl: '/dxm/labels/30.jpg' },
  { label: 'ラベル(ブラックxピンク)', value: '31', imageUrl: '/dxm/labels/31.jpg' },
  { label: 'ラベル(ブラックxパープル)', value: '32', imageUrl: '/dxm/labels/32.jpg' },
  { label: 'ラベル(ブラックxホワイト)', value: '33', imageUrl: '/dxm/labels/33.jpg' },
  { label: 'ラベル(ブラックxグレー)', value: '34', imageUrl: '/dxm/labels/34.jpg' },
  { label: 'ラベル(ブラックxイエロー)', value: '35', imageUrl: '/dxm/labels/35.jpg' },
  { label: 'ラベル(ブラックxシルバー)', value: '36', imageUrl: '/dxm/labels/36.jpg' },
  { label: 'ラベル(ブラックxコルク)', value: '37', imageUrl: '/dxm/labels/37.jpg' },
  { label: 'ラベル(ブラックxオレンジ)', value: '38', imageUrl: '/dxm/labels/38.jpg' },
  { label: 'ラベル(ブラックxブラック)', value: '39', imageUrl: '/dxm/labels/39.jpg' },
  { label: 'ラベル(ブラックxレッド)', value: '40', imageUrl: '/dxm/labels/40.jpg' }
]

// canvas側で使用
const coreGold = '#C2B425'
const coreWhite = '#ebecf0'
const coreBlack = '#1A161A'
export const dxmLabelColorObjs = [
  // カーキ, ブラウン, ゴールド
  { value: '1', outOfEdge: '#4B5924', edge: '#272118', core: '#C0B732' },
  { value: '2', outOfEdge: '#4C1D60', edge: '#4C1D60', core: coreGold },
  { value: '3', outOfEdge: '#ff4c05', edge: '#fff', core: '#27186C' },
  { value: '4', outOfEdge: '#B4C225', edge: '#261865', core: coreGold },
  { value: '5', outOfEdge: '#344928', edge: '#C2C015', core: '#C6C7C2' },
  { value: '6', outOfEdge: '#d9c390', edge: '#251B18', core: '#596542' },
  { value: '7', outOfEdge: '#9C3F4F', edge: '#461D1F', core: coreGold },
  { value: '8', outOfEdge: '#5A7FBC', edge: '#3C529B', core: coreGold },
  { value: '9', outOfEdge: '#D6DCDF', edge: '#141114', core: coreWhite },
  { value: '10', outOfEdge: coreWhite, edge: '#98291C', core: coreWhite },
  { value: '11', outOfEdge: coreWhite, edge: '#B4B6B6', core: coreWhite },
  { value: '12', outOfEdge: coreWhite, edge: '#231D34', core: coreWhite },
  { value: '13', outOfEdge: coreWhite, edge: '#B0B1B5', core: coreWhite },
  { value: '14', outOfEdge: coreWhite, edge: '#816D22', core: coreWhite },
  { value: '15', outOfEdge: coreWhite, edge: '#626574', core: coreWhite },
  { value: '16', outOfEdge: coreWhite, edge: '#304B1E', core: coreWhite },
  { value: '17', outOfEdge: coreWhite, edge: '#451768', core: coreWhite },
  { value: '18', outOfEdge: coreWhite, edge: '#B97992', core: coreWhite },
  { value: '19', outOfEdge: coreWhite, edge: coreGold, core: coreWhite },
  { value: '20', outOfEdge: coreWhite, edge: '#BD5522', core: coreWhite },
  { value: '21', outOfEdge: coreWhite, edge: '#BDB621', core: coreWhite },
  { value: '22', outOfEdge: coreWhite, edge: '#261668', core: coreWhite },
  { value: '23', outOfEdge: coreWhite, edge: '#3F312B', core: coreWhite },
  { value: '24', outOfEdge: coreWhite, edge: '#304A92', core: coreWhite },
  { value: '25', outOfEdge: coreBlack, edge: '#3F312B', core: coreBlack },
  { value: '26', outOfEdge: coreBlack, edge: '#AEA128', core: coreBlack },
  { value: '27', outOfEdge: coreBlack, edge: '#19018c', core: coreBlack },
  { value: '28', outOfEdge: coreBlack, edge: '#120363', core: coreBlack },
  { value: '29', outOfEdge: coreBlack, edge: '#336F34', core: coreBlack },
  { value: '30', outOfEdge: coreBlack, edge: '#86a1f7', core: coreBlack },
  { value: '31', outOfEdge: coreBlack, edge: '#B97992', core: coreBlack },
  { value: '32', outOfEdge: coreBlack, edge: '#451768', core: coreBlack },
  { value: '33', outOfEdge: coreBlack, edge: '#ebecf0', core: coreBlack },
  { value: '34', outOfEdge: coreBlack, edge: '#626574', core: coreBlack },
  { value: '35', outOfEdge: coreBlack, edge: '#BDB621', core: coreBlack },
  { value: '36', outOfEdge: coreBlack, edge: '#B4B6B6', core: coreBlack },
  { value: '37', outOfEdge: coreBlack, edge: '#816D22', core: coreBlack },
  { value: '38', outOfEdge: coreBlack, edge: '#BD5522', core: coreBlack },
  { value: '39', outOfEdge: coreBlack, edge: '#242324', core: coreBlack },
  { value: '40', outOfEdge: coreBlack, edge: '#98291C', core: coreBlack }
]

export const dxmLabelObjs = [...dxmDirectEmbroideryLogoObjs, ...dxmLabelLogoObjs]

const commonPartsObjs = [
  // 共通
  { label: '全体', value: 'all' },
  { label: '捕球面', value: 'catchFace' },
  { label: 'ウェブ', value: 'web' },
  { label: 'ヘリ革', value: 'edge' },
  { label: '親指掛け紐', value: 'thumbHook' },
  { label: '小指掛け紐', value: 'littleHook' },
  { label: '指カバー/指当て', value: 'indexCover' }
]
const backGloveObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2', value: 'thumbWeb' },
  { label: '人差指3', value: 'indexWeb' },
  { label: '人差指4', value: 'indexMiddle' },
  { label: '中指5', value: 'middleIndex' },
  { label: '中指6', value: 'middleRing' },
  { label: '薬指7', value: 'ringMiddle' },
  { label: '薬指8', value: 'ringLittle' },
  { label: '小指9', value: 'littleRing' },
  { label: '小指10', value: 'littleOut' },
  { label: 'バンド', value: 'listBelt' }
]
const backGloveForUBackObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2・人差指3', value: 'thumbWebAndIndexWeb' },
  { label: '人差指4', value: 'indexMiddle' },
  { label: '中指5', value: 'middleIndex' },
  { label: '中指6', value: 'middleRing' },
  { label: '薬指7', value: 'ringMiddle' },
  { label: '薬指8', value: 'ringLittle' },
  { label: '小指9', value: 'littleRing' },
  { label: '小指10', value: 'littleOut' },
  { label: 'バンド', value: 'listBelt' }
]

const backCatcherMittObjs = [
  { label: 'バンド', value: 'listBelt' },
  { label: '親指', value: 'thumb' },
  { label: '人差指・中指1', value: 'indexMiddleRight' },
  { label: '中指2・薬指', value: 'middleLeftRing' },
  { label: '小指', value: 'little' },
  { label: '背面台', value: 'fingerStand' }
]

const backFirstMittObjs = [
  { label: 'バンド', value: 'listBelt' },
  { label: '親指', value: 'thumb' },
  { label: 'ウェブ下', value: 'underWeb' },
  { label: 'ブーメラン', value: 'boomerang' }
]

export const catchFacePartsObjs = [...commonPartsObjs]
export const gloveBackPartsObjects = [...commonPartsObjs, ...backGloveObjs, { label: '裏革', value: 'linings' }]
export const pitcherBackPartsObjs = gloveBackPartsObjects
export const infielderBackPartsObjs = gloveBackPartsObjects
export const infielderBackPartsForUBackObjs = [...commonPartsObjs, ...backGloveForUBackObjs, { label: '裏革', value: 'linings' }]
export const outfielderBackPartsObjs = gloveBackPartsObjects
export const catcherMittCatchFaceObjs = [...commonPartsObjs, { label: 'ターゲット', value: 'catchFaceTarget' }]
export const catcherMittBackPartsObjs = [...commonPartsObjs, { label: '裏革', value: 'linings' }, ...backCatcherMittObjs]
export const firstMittBackPartsObjs = [...commonPartsObjs, { label: '裏革', value: 'linings' }, ...backFirstMittObjs]

export const partsObjs = [
  ...commonPartsObjs,
  ...catchFacePartsObjs,
  ...pitcherBackPartsObjs,
  ...infielderBackPartsObjs,
  ...outfielderBackPartsObjs,
  ...firstMittBackPartsObjs,
  ...catcherMittCatchFaceObjs,
  ...catcherMittBackPartsObjs,
  ...backGloveForUBackObjs,
  { label: '薬指リング', value: 'loopOfRingFingerColor' }
]

export const partsForUBackObjs = [
  ...commonPartsObjs,
  ...catchFacePartsObjs,
  ...pitcherBackPartsObjs,
  ...infielderBackPartsForUBackObjs,
  ...outfielderBackPartsObjs,
  ...firstMittBackPartsObjs,
  ...catcherMittCatchFaceObjs,
  ...catcherMittBackPartsObjs
]

export const dispatchObjects = {
  stitch: stitchColorObjs,
  linings: leatherColorObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: leatherColorObjs,
  catchFace: leatherColorObjs,
  web: leatherColorObjs,
  edge: edgeObjs,
  thumbHook: leatherColorObjs,
  littleHook: leatherColorObjs,
  indexCover: leatherColorObjs,
  thumbOut: leatherColorObjs,
  thumbWeb: leatherColorObjs,
  thumbWebAndIndexWeb: leatherColorObjs,
  indexWeb: leatherColorObjs,
  indexMiddle: leatherColorObjs,
  middleIndex: leatherColorObjs,
  middleRing: leatherColorObjs,
  ringMiddle: leatherColorObjs,
  ringLittle: leatherColorObjs,
  loopOfRingFingerColor: leatherColorObjs,
  littleRing: leatherColorObjs,
  littleOut: leatherColorObjs,
  listBelt: leatherColorObjs,
  thumb: leatherColorObjs,
  boomerang: leatherColorObjs,
  underWeb: leatherColorObjs,
  thumbMachi: leatherColorObjs,
  littleMachi: leatherColorObjs,
  indexAndMiddle: leatherColorObjs,
  fingerStand: leatherColorObjs,
  mouton: moutonObjs,
  dxmLabel: dxmLabelObjs
}

export const tgsLeatherDispatchObjects = {
  stitch: stitchColorObjs,
  linings: tgsLeatherColorObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: tgsLeatherColorObjs,
  catchFace: tgsLeatherColorObjs,
  web: tgsLeatherColorObjs,
  edge: edgeObjs,
  thumbHook: tgsLeatherColorObjs,
  littleHook: tgsLeatherColorObjs,
  indexCover: tgsLeatherColorObjs,
  thumbOut: tgsLeatherColorObjs,
  thumbWeb: tgsLeatherColorObjs,
  thumbWebAndIndexWeb: tgsLeatherColorObjs,
  indexWeb: tgsLeatherColorObjs,
  indexMiddle: tgsLeatherColorObjs,
  middleIndex: tgsLeatherColorObjs,
  middleRing: tgsLeatherColorObjs,
  ringMiddle: tgsLeatherColorObjs,
  ringLittle: tgsLeatherColorObjs,
  loopOfRingFingerColor: tgsLeatherColorObjs,
  littleRing: tgsLeatherColorObjs,
  littleOut: tgsLeatherColorObjs,
  listBelt: tgsLeatherColorObjs,
  thumb: tgsLeatherColorObjs,
  boomerang: tgsLeatherColorObjs,
  underWeb: tgsLeatherColorObjs,
  thumbMachi: tgsLeatherColorObjs,
  littleMachi: tgsLeatherColorObjs,
  indexAndMiddle: tgsLeatherColorObjs,
  fingerStand: tgsLeatherColorObjs,
  mouton: moutonObjs,
  dxmLabel: dxmLabelObjs
}

export const gusLeatherDispatchObjects = {
  stitch: stitchColorObjs,
  linings: gusLeatherColorObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: gusLeatherColorObjs,
  catchFace: gusLeatherColorObjs,
  web: gusLeatherColorObjs,
  edge: edgeObjs,
  thumbHook: gusLeatherColorObjs,
  littleHook: gusLeatherColorObjs,
  indexCover: gusLeatherColorObjs,
  thumbOut: gusLeatherColorObjs,
  thumbWeb: gusLeatherColorObjs,
  thumbWebAndIndexWeb: gusLeatherColorObjs,
  indexWeb: gusLeatherColorObjs,
  indexMiddle: gusLeatherColorObjs,
  middleIndex: gusLeatherColorObjs,
  middleRing: gusLeatherColorObjs,
  ringMiddle: gusLeatherColorObjs,
  ringLittle: gusLeatherColorObjs,
  loopOfRingFingerColor: gusLeatherColorObjs,
  littleRing: gusLeatherColorObjs,
  littleOut: gusLeatherColorObjs,
  listBelt: gusLeatherColorObjs,
  thumb: gusLeatherColorObjs,
  boomerang: gusLeatherColorObjs,
  underWeb: gusLeatherColorObjs,
  thumbMachi: gusLeatherColorObjs,
  littleMachi: gusLeatherColorObjs,
  indexAndMiddle: gusLeatherColorObjs,
  fingerStand: gusLeatherColorObjs,
  mouton: moutonObjs,
  dxmLabel: dxmLabelObjs
}

export const dtsLeatherDispatchObjects = {
  stitch: stitchColorObjs,
  linings: dtsLeatherColorObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: dtsLeatherColorObjs,
  catchFace: dtsLeatherColorObjs,
  web: dtsLeatherColorObjs,
  edge: edgeObjs,
  thumbHook: dtsLeatherColorObjs,
  littleHook: dtsLeatherColorObjs,
  indexCover: dtsLeatherColorObjs,
  ringLittle: dtsLeatherColorObjs,
  listBelt: dtsLeatherColorObjs,
  boomerang: dtsLeatherColorObjs, // first
  underWeb: dtsLeatherColorObjs, // first
  thumb: dtsLeatherColorObjs, // catcher, first
  indexMiddleRight: dtsLeatherColorObjs, // catcher
  middleLeftRing: dtsLeatherColorObjs, // catcher
  little: dtsLeatherColorObjs, // catcher
  thumbMachi: dtsLeatherColorObjs, // catcher
  littleMachi: dtsLeatherColorObjs, // catcher
  fingerStand: dtsLeatherColorObjs, // catcher
  catchFaceTarget: dtsLeatherColorObjs, // catcher
  loopOfRingFingerColor: dtsLeatherColorObjs,
  mouton: moutonObjs,
  dxmLabel: dxmLabelObjs
}

// export const PARTS_BUTTON_OPTION = 'dxm-parts-button-option'
export const LEATHER_COLOR_BUTTON_OPTION = 'dxm-leather-color-button-option'
export const LACE_COLOR_BUTTON_OPTION = 'dxm-lace-color-button-option'
export const EDGE_COLOR_BUTTON_OPTION = 'dxm-edge-color-button-option'
export const STITCH_COLOR_BUTTON_OPTION = 'dxm-stitch-color-button-option'
export const HAMIDASHI_COLOR_BUTTON_OPTION = 'dxm-hamidashi-color-button-option'
export const MOUTON_BUTTON_OPTION = 'dxm-mouton-button-option'
export const LABEL_BUTTON_OPTION = 'dxm-label-button-option'
export const DIRECT_EMBROIDERY_LABEL_BUTTON_OPTION = 'dxm-direct-embroidery-label-button-option'
